module.exports = __webpack_public_path__ + "static/macbook-frame-94ed97122200a2a49c7931717adea930.png";